const AICAPCONF = {
  customStyles: {
    gap: `10px`
  },
  wmServerConfig: {
    configServer: `webzjac.reg.163.com`,
    apiServer: `webzjac.reg.163.com`,
    staticServer: `acstatic-dun.126.net`
  },
  apiServer: [ `webzjcaptcha.reg.163.com`, `c.dun.163yun.com` ]
  // config对象，参数配置
}

export {AICAPCONF}



// WEBPACK FOOTER //
// ./src/util/config.js